import {createReducer, on} from "@ngrx/store";
import {setHaveGoodsStore} from "./have-goods.actions";

const initialState = false;

export const haveGoodsReducer = createReducer(
  initialState,
  on(setHaveGoodsStore, (state, action) => state = action.value),
);
